import { Link } from 'react-router-dom';
import '../App.css';

const Home = () => {
  return (
    <div className="main-container">
      <header className="header-text-container">
        <h1>Practice Capsule</h1>
        <p>Available now on iPhone</p>
      </header>

      <section>
        <div className="button-container">
          <Link className="action-button" to="/privacy-policy">Privacy Policy</Link>
          <Link className="action-button" to="/terms-and-conditions">Terms And Conditions</Link>
          {/* <a className="action-button" href="mailto:newmodeapps@gmail.com?subject=Practice Capsule: Delete My Data&body=Please delete the data associated with my email: ">Delete My Data</a> */}
        </div>
      </section>
    </div>
  );
};

export default Home;
